import { IWithdrawDetailsV2 } from '@/modules/transaction/services/product-withdraw';

export enum EProductTypes {
  FIXED_INCOME = 'fixed-income',
  GOVERNMENT_BOND = 'government-bond',
  FUNDS = 'funds'
}

export function errorText(
  data: IWithdrawDetailsV2,
  inputValue: number,
  productType: string
) {
  const { minimumRedemption, availableToRedemption, minimumToStay } = data;

  if (inputValue === availableToRedemption.value) {
    return '';
  }

  if (inputValue > availableToRedemption.value) {
    return 'Valor maior que o saldo disponível';
  }

  if (inputValue > 0 && inputValue < minimumRedemption.value) {
    return 'Valor menor que o mínimo para resgate';
  }

  if (productType === EProductTypes.FUNDS && minimumToStay) {
    if (
      inputValue > 0 &&
      inputValue < availableToRedemption.value &&
      availableToRedemption.value - inputValue < minimumToStay.value
    ) {
      return 'O valor deve respeitar o mínimo de permanência';
    }
  }

  return '';
}

export function errorStatus(
  data: IWithdrawDetailsV2,
  inputValue: number,
  productType: string
) {
  const { minimumRedemption, availableToRedemption, minimumToStay } = data;

  if (inputValue === availableToRedemption.value) {
    return '';
  }

  if (inputValue > availableToRedemption.value) {
    return 'error';
  }

  if (inputValue > 0 && inputValue < minimumRedemption.value) {
    return 'error';
  }

  if (productType === EProductTypes.FUNDS && minimumToStay) {
    if (
      inputValue > 0 &&
      inputValue < availableToRedemption.value &&
      availableToRedemption.value - inputValue < minimumToStay.value
    ) {
      return 'error';
    }
  }

  return '';
}

export function listDetails(
  data: IWithdrawDetailsV2,
  netBalance: string,
  productType: string,
  loading: boolean
) {
  const { minimumRedemption, minimumToStay, totalRedemptionPeriod } = data;

  const list = [
    {
      label: 'Valor líquido',
      value: netBalance,
      show: true,
      loading
    },
    {
      label: minimumRedemption.label,
      value: minimumRedemption.formatted,
      show: Boolean(minimumRedemption),
      loading: false
    },
    {
      label: minimumToStay.label || '',
      value: minimumToStay.formatted || '',
      show: productType === EProductTypes.FUNDS,
      loading: false
    },
    {
      label: totalRedemptionPeriod.label,
      value: totalRedemptionPeriod.value,
      show: Boolean(totalRedemptionPeriod),
      loading: false
    }
  ];

  return list.filter(item => item.show);
}
